var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 18,
    viewBox: "0 0 140 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.911 9C100.911 13.9315 104.918 18 109.911 18C114.842 18 118.911 13.9932 118.911 9C118.911 4.06849 114.904 0 109.911 0C104.918 0 100.911 4.00685 100.911 9Z",
    fill: "#E4032E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.60269H5.60959V13.4383H14.3014V16.3356H0V1.60269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6917 1.35617C33.6575 1.35617 37.2945 4.25343 37.2945 9.00001C37.2945 13.6849 33.5958 16.6438 26.6917 16.6438C19.7876 16.6438 16.089 13.6849 16.089 9.00001C16.089 4.25343 19.726 1.35617 26.6917 1.35617ZM26.6917 13.6849C30.0821 13.6849 31.4383 11.4041 31.4383 8.93836C31.4383 6.34932 30.0821 4.19179 26.6917 4.19179C23.3013 4.19179 21.8835 6.34932 21.8835 8.93836C21.8835 11.4041 23.3013 13.6849 26.6917 13.6849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7671 4.2534H83.589V1.29449H99.6164V4.2534H94.4383V16.3356H88.7671V4.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8424 7.64384V10.4795H55.1095V13.5C54.6164 13.6849 53.8766 13.7466 53.1369 13.7466C49.0068 13.7466 46.1095 12.0206 46.1095 9.06165C46.1095 6.0411 49.0068 4.31507 52.8903 4.31507H60.1027V1.35617H54.3082C54.0616 1.35617 53.815 1.35617 53.6301 1.35617C45.863 1.35617 40.315 3.51371 40.315 9.06165C40.2534 14.6096 46.7876 16.6438 52.3972 16.6438C54.3082 16.6438 57.0205 16.5822 60.5342 15.9658V7.64384H51.8424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8903 5.67124C70.8903 4.56165 72.6164 4.31507 74.0342 4.31507H79.7054V1.35617H74.8972C74.7123 1.35617 74.5273 1.35617 74.3424 1.35617C70.089 1.35617 65.1575 2.34247 65.1575 5.85617C65.1575 11.2192 75.1438 9.49316 75.1438 12.2671C75.1438 13.4384 73.4794 13.6849 71.6917 13.6849C69.3493 13.6849 67.315 13.2534 65.8972 12.6986L65.404 15.9658C67.2534 16.3973 69.7191 16.5822 71.6917 16.5822C76.3766 16.5822 80.9999 15.5343 80.9999 11.7123C80.8766 6.41096 70.8903 8.01371 70.8903 5.67124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.712 12.3288C136.665 10.5411 136.541 9.43152 134.692 9.06166V9.00001C136.973 8.81508 138.76 7.21234 138.76 5.30138C138.76 3.26713 136.726 1.60275 134.26 1.54111H121.932V8.69179V9.06166V16.3356H127.541V10.4795H128.712C130.808 10.4795 131.548 11.0959 132.658 13.6849L133.891 16.3356H139.747L137.712 12.3288ZM127.603 4.25344H131.856C132.781 4.25344 133.521 4.99316 133.521 5.91782C133.521 6.84248 132.781 7.5822 131.856 7.5822H127.603V4.25344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.808,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.4c7992eba91451766e375da28ae61cbc.svg";